import {Component, OnInit} from '@angular/core';
import {Helper} from '../../../../helpers/helper.service';
import {FormlyFormOptions} from '@ngx-formly/core';
import {environment} from '../../../../../environments/environment';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {UntypedFormGroup} from '@angular/forms';
import {Part, PartForm} from '../../../Models/Part';
import {PartsService} from '../../../Services/parts.service';
import {createPartsFormConfig} from '../configs';

@Component({
  selector: 'app-manage-parts',
  templateUrl: './manage-parts.component.html',
  styleUrls: ['./manage-parts.component.scss']
})
export class ManagePartsComponent implements OnInit {
  public classicBox;
  public partForm: PartForm = {
    name: '',
    code: '',
    stockAmount: 0,
    supplierPart: {
      name: '',
      contactPerson: '',
      email: '',
      supplierPartName: '',
      supplierPartCode: '',
      remark: ''
    }
  };
  public enableSave = true;
  form = new UntypedFormGroup({});
  model: any = {};
  public isEdit = false;
  public partId: number;
  options: FormlyFormOptions = {};

  constructor(
    public helper: Helper,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private partsService: PartsService,
    private router: Router
  ) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      new Promise((resolve) => {
        if (Helper.isDefined(params['id'])) {
          this.partId = params['id'];
          this.isEdit = true;
          this.partsService.getPartItem(this.partId).subscribe(resolve);
        } else {
          resolve(new Part());
        }
      }).then(part => {
        if (this.isEdit) {
          const partData = part as Part;
          this.partForm = {
            name: partData.name || '',
            code: partData.code || '',
            stockAmount: partData.stockAmount || 0,
            supplierPart: {
              name: partData.supplierPart?.name || '',
              contactPerson: partData.supplierPart?.contactPerson || '',
              email: partData.supplierPart?.email || '',
              supplierPartName: partData.supplierPart?.supplierPartName || '',
              supplierPartCode: partData.supplierPart?.supplierPartCode || '',
              remark: partData.supplierPart?.remark || ''
            },
          };
        }
      }).then(() => {
        this.classicBox = createPartsFormConfig({
          translate: this.translate,
          environment: environment
        });
      });
    });
  }

  enableButton(event: boolean) {
    this.enableSave = event;
  }

  submitItem(next: boolean) {
    if (next) {
      const partData = JSON.parse(JSON.stringify(this.partForm));
      
      this.partsService.managePart(partData, this.isEdit, this.partId).subscribe(() => {
        this.router.navigateByUrl('/back-office/parts/overview');
      });
    } else {
      this.router.navigateByUrl('/back-office/parts/overview');
    }
  }
}
